<template>
    <div class="first-banner">
        <h2>Firsr</h2>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.first-banner {
    border: 2px solid red;
    
}
</style>